import(/* webpackMode: "eager", webpackExports: ["ValueProposition"] */ "/opt/build/repo/src/app/components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PortfolioHero","CaseStudyCard"] */ "/opt/build/repo/src/app/portfolio/components.tsx");
